import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import type {
  UnsealCardDialogQuery,
  UnsealCardDialogQueryVariables,
} from './__generated__/index.withFetch.graphql.ts';
import { UnsealCardDialog } from './index.tsx';

const query = gql`
  query UnsealCardDialogQuery($slugs: [String!]!) {
    anyCards(slugs: $slugs) {
      slug
      ...UnsealCardDialog_anyCard
    }
  }
  ${UnsealCardDialog.fragments.anyCard}
` as TypedDocumentNode<UnsealCardDialogQuery, UnsealCardDialogQueryVariables>;

type Props = {
  open?: boolean;
  rarity: Rarity;
  selectedCardsSlug?: string;
  unsealing?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const UnsealCardDialogWithFetch = ({
  open = false,
  rarity,
  selectedCardsSlug,
  unsealing = false,
  onClose,
  onConfirm,
}: Props) => {
  const { data, loading } = useQuery(query, {
    variables: {
      slugs: selectedCardsSlug ? [selectedCardsSlug] : [],
    },
    skip: !open || !selectedCardsSlug,
  });

  const card = data?.anyCards?.[0];
  return (
    <UnsealCardDialog
      open={Boolean(open && data)}
      rarity={rarity}
      loading={loading}
      unsealing={unsealing}
      card={card}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
